import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ShopsTemplate } from 'components/Templates'

const Shops: FC = () => {
  return (
    <Layout headline={'出店店舗一覧'} title={'出店店舗一覧'}>
      <ShopsTemplate />
    </Layout>
  )
}

export default Shops
